import { useMutation } from '@apollo/react-hooks'
import { VALID_AND_CREATE_NEW_RESULT_TASK } from '../../../functions/graphql/mutations'

export const useValidAndCreateNewResultTask = () => useMutation(VALID_AND_CREATE_NEW_RESULT_TASK)
